import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { SurveysApi } from 'entities/Surveys'
import { SurveysStatus } from 'entities/Surveys/api/types'
import { type SurveyRow } from 'entities/Surveys/model/SurveyRow'
import { openDisableSurveyModal } from 'pages/surveys/ui/actions/disableSurvey/openDisableSurveyModal'

export const toggleSurveyActive = async (row: SurveyRow): Promise<void> => {
  const isActive = row.status === SurveysStatus.Active

  if (isActive) {
    openDisableSurveyModal(row.id, (data) => {
      row.syncOrigin(data)
    })
    return
  }

  try {
    const { data } = await SurveysApi.activateSurvey(row.id, { is_active: true })
    row.syncOrigin(data)
    toastStore.add({ type: 'success', title: 'Survey activated' })
  } catch (error) {
    logger.error(error)
    toastStore.add({ title: 'Something went wrong', desc: 'Please try again', type: 'error' })
  }
}
